export const findTopmostParentCategory = (targetId, categories) => {
  let result = null;

  function traverse(categories, ancestors) {
    for (const category of categories) {
      if (category.id === targetId) {
        result = ancestors.length > 0 ? ancestors[0] : category;
        return category;
      }

      if (category.children && category.children.length > 0) {
        if (traverse(category.children, ancestors.concat(category))) {
          return category;
        }
      }
    }
    return false;
  }

  traverse(categories, []);
  return result;
};
